import React from 'react';
import { Input } from 'antd';
import styled from 'styled-components';

const { TextArea } = Input;
const StyledTextArea = styled(TextArea)`
  &.ant-input {
    border-radius: 0.5rem;
    border: 1px solid #aebeca;
    &:disabled {
      color: #627d95;
      border: solid 1px #aebeca;
      background-color: #f2f6fa;
    }
    &::placeholder {
      color: #aebeca;
    }
  }
  &.ant-input-lg {
    padding: 0.813rem 1rem;
    height: auto;
    line-height: 1.43;
    font-size: 0.875rem;
    color: #061c2e;
    white-space: pre-line;
  }
  &:not(.ant-input-affix-wrapper) .ant-input-lg:hover,
  &.ant-input:hover {
    border: solid 1px #22bf61;
  }
  &:not(.ant-input-affix-wrapper) .ant-input-lg:focus,
  &.ant-input:focus {
    box-shadow: 0 0 8px 0 #34ce72;
    border-color: transparent;
  }
`;

const Textarea = ({ ...rest }) => {
  return <StyledTextArea {...rest} />;
};

export default Textarea;
